// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calculation {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 27px;
}
.calculation > form
{
  display: flex;
  flex-direction: column;
  gap: 27px;
}

.calculation__header {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 96px;
}

.about__order_mobile {
  position: relative;
  display: none;
  width: 100%;
  height: 56px;
  border: 1px solid #dde1eb;
  border-radius: 8px;
}

.about__order_mobile.active::after {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(18, 18, 18, 0.7);
  z-index: 999999;
}

.about__order_mobile > label {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.about__order_mobile > label span {
  color: #777f87;
  font-size: 16px;
  font-weight: 600;
}

.about__order_mobile > label svg {
  color: #0c6b60;
  font-size: 24px;
}

.about__order_mobile__content {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 400px;
  width: 100%;
  background: #fff;
  z-index: 9999999;
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  padding: 20px;

  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 0px 73.6px 0px rgba(42, 77, 114, 0.19);
}

.about__order_mobile__content.active {
  display: flex;
}

.about__order_mobile__content > p {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.about__order_mobile__content > p span {
  color: #777f87;
  font-size: 18px;
  font-weight: 600;
}

.about__order_mobile__content > p svg {
  color: #0c6b60;
  font-size: 28px;
  transform: rotate(180deg);
}

.about__order_mobile__content > input {
  width: 100%;
  height: 42px;
  border-radius: 8px;
  border: 1px solid #dde1eb;
  background: var(--White, #fff);
  padding: 0 16px;
}

.about__order_mobile__content > .order__price {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background: #dde1eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
}

.about__order_mobile__content > .order__price p {
  color: var(--Dark-Gray, #60656e);
  font-size: 12px;
  font-weight: 500;
}

.about__order_mobile__content > .order__price span {
  color: #434343;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
}

.about__order_mobile__content > div {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.about__order_mobile__content > div button {
  width: calc((100% - 10px) / 2);
  height: 42px;
  border-radius: 8px;
  background: #0c6b60;
  color: var(--White, #fff);
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  padding: 0 10px;
}

.about__order_mobile__content > button {
  width: 100%;
  height: 42px;
  border-radius: 8px;
  background: #0c6b60;
  color: var(--White, #fff);
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.about__order_mobile__content > a 
{
  width: 100%;
  height: 42px;
  border-radius: 8px;
  background: #0c6b60;
  color: var(--White, #fff);
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.about__order_mobile__content > a > button 
{
  background: unset;
  border:none;
  font-size: 14px;
  font-weight: 600;
  color: var(--White, #fff);
}

.calculation__box {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
}

.calculation__title {
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  padding: 6px 13px;
  border-radius: 4px;
  background: #0c6b60;
}

/* calculation__item_add */

.calculation__title.v2 {
  color: #777f87;
  background: transparent;
}

.calculation__header_left {
  width: calc(100% - 496px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
}

.calculation__grades {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  list-style: none;
}

.calculation__grade {
display: flex;
  align-items: center;
  position: relative;
  width: calc((100% - 60px) / 3);
  border: 2px solid #b2bac663;
  border-radius: 8px;
  padding: 15px;
  cursor: pointer;
}

.calculation__grade.active {
  border: 2px solid #0c6b60;
}


..calculation__grades.washing .calculation__grade
{
  width: calc((100% - 60px) / 2);
}

.calculation__grade > img {
  width: 100%;
}

.calculation__grade > .checkbox {
  position: absolute;
  bottom: -11px;
  right: 11px;
  width: 22px;
  height: 22px;
  display: none;
}

.calculation__grade > .checkbox.active {
  display: block;
}


.calculation__select_color {
  width: calc(((100% - 60px) / 3) * 2 + 30px);
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  border: 1px solid #dde1eb;
  background: var(--White, #fff);
  padding: 0 16px;
  cursor: pointer;
}

.calculation__select_color > i {
  padding: 8px 16px;
  border-radius: 4px;
  background: #60656e;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
}

.calculation__select_color > span {
  display: flex;
  align-items: center;
  gap: 12px;
}

.calculation__select_color > span img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.about__order {
  width: 400px;
  border-radius: 30px;
  background: #fff;
  box-shadow: 0px 0px 73.6px 0px rgba(42, 77, 114, 0.19);
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.about__order > h2 {
  color: #777f87;
  font-size: 18px;
  font-weight: 600;
}

.about__order > input {
  width: 100%;
  height: 42px;
  border-radius: 8px;
  border: 1px solid #dde1eb;
  background: var(--White, #fff);
  padding: 0 16px;
  color: #777f87;
  font-size: 16px;
  font-weight: 500;
}

.about__order > input::placeholder {
  color: var(--Placeholder, #b2bac6);
}

.about__order > input[name="phone"] {
  letter-spacing: 2px;
}

.about__order > .order__price {
  width: 100%;
  height: 68px;
  border-radius: 8px;
  background: #dde1eb;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* calculation__item_info */

.about__order > .order__price p {
  color: var(--Dark-Gray, #60656e);
  font-size: 16px;
  font-weight: 500;
  flex: 0 0 80px;
}

.about__order > .order__price span {
  color: #434343;
  font-size: 32px;
  font-weight: 700;
}

.about__order > .order__buttons {
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.about__order > .order__buttons > button, .about__order > a {
  width: calc((100% - 16px) / 2);
  border-radius: 8px;
  background: #0c6b60;
  color: var(--White, #fff);
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.about__order > a
{
  width: 100%;
}
.about__order > a > button
{
    border-radius: 8px;
    background: #0c6b60;
    border: none;
    color: var(--White, #fff);
    font-size: 16px;
    font-weight: 600;
    padding: 16px 5px;
    width: 100%;
    cursor: pointer;
}

.about__order > .order__buttons > button svg 
{
  margin-right: 5px;

}

.about__order > button {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #0c6b60;
  color: var(--White, #fff);
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  gap: 10px;
}

/* --------- calculation__detail ---------- */
.calculation__detail {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.calculation__item {
  position: relative;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #dde1eb;
  background: #dde1eb;
}

.calculation__item_top {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 22px;
  gap: 18px;
  background: #fff;
  border-radius: 8px;
}

.calculation__item_top > :where(div, label) {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.calculation__item_top > :where(div, label) > input {
  width: 100%;
  height: 45px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid #dde1eb;
  color: #777f87;
  font-size: 16px;
  font-weight: 500;
}

.calculation__item_top > :where(div, label).w270 {
  width: 270px;
}
.calculation__item_top > :where(div, label).w145 {
  width: 145px;
}
.calculation__item_top > :where(div, label).w135 {
  width: 135px;
}
.calculation__item_top > :where(div, label).w100 {
  width: 100px;
}

.calculation__item_top > :where(div, label).w100 input {
  text-align: center;
}

.calculation__item_top > :where(div, label) > span {
  color: #8f98a5;
  font-size: 12px;
}

.calculation__item_info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 16px;
}

.calculation__item_info > p {
  padding: 16px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 15px;
  border-color: #DDE1EB;
  border-width: 1px;
  border-style: solid;
}

.calculation__item_info > p i {
  max-width: 120px;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
}

.calculation__item_info > p span {
  font-size: 28px;
  font-weight: 700;
}

.select {
  position: relative;
  width: 100%;
  height: 45px;
  max-width: 540px;
  background: yellow;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 16px;
  border: 1px solid var(--Border, #dde1eb);
  border-radius: 8px;
  background: var(--White, #fff);
}

.select.input {
  padding: 0 16px;
}

.select.input > input {
  padding: 0;
}

.select > input {
  width: 100%;
  height: 100%;
  padding: 0 16px;
  border-radius: 8px;
  color: var(--Dark, #23262a);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.select > svg {
  font-size: 20px;
  transition: all 0.3s ease;
}

.select.active svg {
  transform: rotate(180deg);
}

.select__list {
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  z-index: 999;
  width: 100%;
  max-height: 0px;
  overflow-y: auto;
  border: 1px solid transparent;
  border-radius: 8px;
  background: var(--White, #fff);
  transition: all 0.3s ease;
}

.select__list > li {
  height: 40px;
  padding: 0 16px;
  font-size: 16px;
  font-weight: 500;
  color: var(--Dark, #23262a);
  cursor: pointer;
  display: flex;
  align-items: center;
}

.select__list > :nth-child(even) {
  background: var(--Light, #f4f5f7);
}

.select__list > :nth-child(even):hover {
  background: var(--Light, #f4f5f7e9);
}

.select__list > :nth-child(odd):hover {
  background: var(--Light, #fbfbfb);
}

.select.active .select__list {
  max-height: 200px;
  border: 1px solid var(--Border, #dde1eb);
}

.calculation__item_bottom {
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 15px 16px;
  gap: 43px;
  position: relative;
}

.calculation__item_bottom > p {
  display: flex;
  align-items: center;
  gap: 5px;
}

.calculation__item_bottom > p.red_noty
{
    color: red;
    font-size: 12px;
    display: block;
    margin-bottom: 0px;
    position: absolute;
    top: 7px;
    right: 10px;
}
.calculation__item_bottom > p > :where(i, span) {
  font-style: normal;
  color: #434343;
  font-size: 12px;
  font-weight: 400;
}

.calculation__item_add {
  position: absolute;
  right: 11px;
  bottom: -11px;
  /* width: 22px; */
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0c6b60;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
  padding: 0 10px;
}

.calculation__item_add > span {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
}

.calculation__item_remove
{
  position: absolute;
    right: 205px;
    bottom: -11px;
    /* width: 22px; */
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #af0e0e;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    padding: 0 10px;
}

.calculation__item_remove > span {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
}

.calculation__item_remove > svg
{
    transform: rotate(45deg);
}

/* ------------------------- */
.calculation__additional {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  border: 1px solid #dde1eb;
  background: #fff;
  padding: 20px 40px;
  gap: 30px;
}


.calculation__additional table {
    width: 100%;
    gap: 16px;
}

.calculation__additional table thead tr {
    width: 100%;
    background: #fff;
    z-index: 99;
    border: 1px solid transparent !important;
}

.calculation__additional table tr {
  width: 100%;
    background: #DDE1EB;
    border: 1px solid transparent;
    margin-bottom: 15px;
}

.calculation__additional table thead tr
{
  margin: 0;
}

.calculation__additional table tr {
      width: 100%;
    height: 65px;
    border-radius: 8px;
}

.calculation__additional table tr:nth-child(odd) {
  background: transparent;
    border: 1px solid #dde1eb;
}

.calculation__additional table tr td {
    height: 30px;
    border-right: 1px solid #b2bac6;
    padding: 0 5px;
    color: #b2bac6;
    font-size: 10px;
    font-weight: 500;
}

.calculation__additional table tbody tr td 
{

  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #424242;
}
.calculation__additional table tr td
{
  width: 10%;
  text-align: center;
}
.calculation__additional table tr td:last-child {
    border-right: none;
}

.calculation__additional table tr td.title 
{
  justify-content: left;
  width: 60%;
}
.calculation__additional table tr td input
{

  background: #FFFFFF;
  border: 1px solid #DDE1EB;
  border-radius: 8px;
  text-align: center;
  padding: 10px;
  width: 50px;
}
.calculation__additional table tr td .remove
{
    height: 25px;
    background: #af0e0e;
    color: #fff;
    font-size: 19px;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    padding: 0 2px;
}

.calculation__additional table tr td .remove svg 
{
    transform: rotate(45deg);
    margin-top: 2px;
}

.calculation__additional > button {
  min-width: 300px;
  color: #0c6b60;
  font-size: 16px;
  font-weight: 500;
  border: none;
  background: transparent;
  text-decoration-line: underline;
  cursor: pointer;
}

.calculation__additional > p {
  max-width: 650px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.calculation__additional > p span {
  color: #000;
  font-size: 15px;
  font-weight: 400;
}

/* ------------------------- */

.calculation__total {
  width: 100%;
  padding: 30px;
  border-radius: 8px;
  background: #dde1eb;
  display: flex;
  align-items: center;
  gap: 22px;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}

.calculation__total > :where(p, div, button) {
  width: calc((100% - 44px) / 3);
  height: 56px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.calculation__total > p {
  justify-content: space-between;
  background: #fff;
  padding: 0 16px;
}

.calculation__total > p i {
  color: var(--Dark-Gray, #60656e);
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
}

.calculation__total > p span {
  color: #434343;
  font-size: 30px;
  font-weight: 700;
}

.calculation__total > div {
  display: flex;
  align-items: center;
  gap: 22px;
}

.calculation__total > div button {
  width: calc((100% - 22px) / 2);
  height: 100%;
  border-radius: 8px;
  background: #0c6b60;
  border: none;
  color: var(--White, #fff);
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  padding: 0 16px;
  cursor: pointer;
}

.calculation__total.three_button > div button
{
  width: calc(100% - 22px);
}

.calculation__total > button {
  background: #0c6b60;
  border: none;
  color: var(--White, #fff);
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  gap: 5px;
}

.calculation__total > a 
{
    background: #0c6b60;
    border: none;
    color: var(--White, #fff);
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    gap: 5px;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc((100% - 22px) / 2);
    border-radius: 8px;
}

.calculation__total > a > button 
{
  color: var(--White, #fff);
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  background: unset;
  border:none;
  padding: 0 16px;
}

/* --------- Media Query for Calculation Page ---------  */

@media (max-width: 1280px) {
  .calculation__item_top > :where(div, label).w270 {
    width: 250px;
  }
  .calculation__item_top > :where(div, label).w145 {
    width: 130px;
  }
  .calculation__item_top > :where(div, label).w135 {
    width: 110px;
  }
  .calculation__item_top > :where(div, label).w100 {
    width: 80px;
  }
}

@media (max-width: 1150px) {
  .calculation__header {
    gap: 40px;
  }

  .calculation__header_left {
    width: calc(100% - 440px);
    gap: 30px;
  }

  .calculation__grades {
    gap: 15px;
  }

  .calculation__grade {
    width: calc((100% - 30px) / 3);
    padding: 10px;
  }

  .calculation__select_color {
    width: 100%;
  }

  .calculation__select_color > i {
    font-size: 14px;
  }

  .calculation__item_top > :where(div, label) input {
    font-size: 14px;
  }

  .calculation__item_top > :where(div, label).w270 {
    width: 230px;
  }
  .calculation__item_top > :where(div, label).w145 {
    width: 105px;
  }
  .calculation__item_top > :where(div, label).w135 {
    width: 90px;
  }
  .calculation__item_top > :where(div, label).w100 {
    width: 70px;
  }

  .calculation__total > p i {
    font-size: 14px;
  }

  .calculation__total > p span {
    font-size: 24px;
    font-weight: 700;
  }

  .calculation__total > div button {
    font-size: 14px;
  }

  .calculation__item_info > p {
    padding: 10px 15px;
  }

  .calculation__item_info > p i {
    max-width: 120px;
    font-size: 10px;
  }

  .calculation__item_info > p span {
    font-size: 24px;
  }
}

@media (max-width: 1024px) {
  .calculation__header {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .about__order {
    display: none;
  }

  .about__order_mobile {
    display: flex;
  }

  .calculation__header_left {
    width: 100%;
  }

  .calculation__grade {
    width: calc((100% - 45px) / 4);
  }

  .calculation__title {
    font-size: 16px;
    font-weight: 600;
    padding: 5px 10px;
  }

  .calculation__total {
    padding: 30px;
    gap: 20px;
    flex-wrap: wrap;
  }

  .calculation__total > p {
    width: 100%;
  }

  .calculation__total > :where(div, button) {
    width: calc((100% - 20px) / 2);
  }
}

@media (max-width: 768px) {
  .calculation__grade {
    width: calc((100% - 30px) / 3);
  }

  .calculation__item_info {
    width: 100%;
    gap: 8px;
    padding-top: 10px;
  }

  .calculation__item_info > p {
    width: calc((100% - 8px) / 2);
    padding: 15px;
  }

  .calculation__item_info > p span {
    font-size: 20px;
  }

  .calculation__additional {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    padding: 25px 20px;
    gap: 20px;
  }

  .calculation__additional > button {
    max-width: auto;
    font-size: 14px;
  }

  .calculation__additional > p {
    flex-direction: column;
  }

  .calculation__additional > p span {
    font-size: 14px;
    text-align: center;
  }

  .calculation__total > div {
    width: 100%;
  }

  .calculation__total > button {
    width: 100%;
  }
}

@media (max-width: 525px) {
  .calculation__grade {
    width: calc((100% - 15px) / 2);
  }

  .calculation__item_bottom {
    padding: 15px;
    gap: 20px;
  }

  .calculation__item_info p {
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .calculation__item_info i {
    text-align: center;
  }

  .calculation__item_top {
    gap: 10px;
  }

  .calculation__item_top > :where(div, label) {
    width: calc((100% - 10px) / 2) !important;
  }

  .calculation__total {
    padding: 16px;
    gap: 10px;
  }

  .calculation__total > p {
    padding: 0 14px;
  }

  .calculation__total > p i {
    font-size: 12px;
  }

  .calculation__total > p span {
    font-size: 24px;
  }

  .calculation__total > div {
    gap: 10px;
  }

  .calculation__total > div button {
    width: calc((100% - 10px) / 2);
    font-size: 14px;
  }

  .calculation__total > button {
    font-size: 14px;
  }
}

@media (max-width: 400px) {
  .calculation__item_top > :where(div) {
    width: 100% !important;
  }

  .calculation__item_bottom {
    flex-wrap: wrap;
  }
}


.calculation__select_new .react-select__control
{
  width: 100%;
}
.calculation__select_new .react-select__value-container .react-select__single-value .span
{
    font-size: 14px !important;
    padding: 4px 0!important;
}

.calculation__select_new img
{
    width: 20px !important;
    height: 20px !important;
    margin-top: 12px !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/archive/calculation.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,aAAa;;EAEb,kBAAkB;EAClB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;;EAEE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,0BAA0B;;AAE1B;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;AACA,aAAa;EACX,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,2CAA2C;EAC3C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,sDAAsD;EACtD,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,2BAA2B;;AAE3B;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;AACb;AACA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;;EAEE,iBAAiB;;AAEnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,SAAS;AACX;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;IAEI,UAAU;IACV,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;IAChB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;;AAGA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,wCAAwC;AAC5C;;AAEA;EACE,WAAW;IACT,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;;EAEE,SAAS;AACX;;AAEA;MACM,WAAW;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;EACE,uBAAuB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,UAAU;EACV,kBAAkB;AACpB;AACA;IACI,kBAAkB;AACtB;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;AACZ;AACA;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;AACA;;IAEI,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,8BAA8B;;AAE9B;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;IACP,mBAAmB;IACnB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,QAAQ;AACV;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA,0DAA0D;;AAE1D;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;IAC7B,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA;;EAEE,WAAW;AACb;AACA;;IAEI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;;IAEI,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;AAC/B","sourcesContent":[".calculation {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 27px;\n}\n.calculation > form\n{\n  display: flex;\n  flex-direction: column;\n  gap: 27px;\n}\n\n.calculation__header {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  gap: 96px;\n}\n\n.about__order_mobile {\n  position: relative;\n  display: none;\n  width: 100%;\n  height: 56px;\n  border: 1px solid #dde1eb;\n  border-radius: 8px;\n}\n\n.about__order_mobile.active::after {\n  content: \"\";\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background: rgba(18, 18, 18, 0.7);\n  z-index: 999999;\n}\n\n.about__order_mobile > label {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n}\n\n.about__order_mobile > label span {\n  color: #777f87;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.about__order_mobile > label svg {\n  color: #0c6b60;\n  font-size: 24px;\n}\n\n.about__order_mobile__content {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  max-width: 400px;\n  width: 100%;\n  background: #fff;\n  z-index: 9999999;\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 20px;\n\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0px 0px 73.6px 0px rgba(42, 77, 114, 0.19);\n}\n\n.about__order_mobile__content.active {\n  display: flex;\n}\n\n.about__order_mobile__content > p {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.about__order_mobile__content > p span {\n  color: #777f87;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.about__order_mobile__content > p svg {\n  color: #0c6b60;\n  font-size: 28px;\n  transform: rotate(180deg);\n}\n\n.about__order_mobile__content > input {\n  width: 100%;\n  height: 42px;\n  border-radius: 8px;\n  border: 1px solid #dde1eb;\n  background: var(--White, #fff);\n  padding: 0 16px;\n}\n\n.about__order_mobile__content > .order__price {\n  width: 100%;\n  height: 48px;\n  border-radius: 8px;\n  background: #dde1eb;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 14px;\n}\n\n.about__order_mobile__content > .order__price p {\n  color: var(--Dark-Gray, #60656e);\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.about__order_mobile__content > .order__price span {\n  color: #434343;\n  text-align: center;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.about__order_mobile__content > div {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.about__order_mobile__content > div button {\n  width: calc((100% - 10px) / 2);\n  height: 42px;\n  border-radius: 8px;\n  background: #0c6b60;\n  color: var(--White, #fff);\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  padding: 0 10px;\n}\n\n.about__order_mobile__content > button {\n  width: 100%;\n  height: 42px;\n  border-radius: 8px;\n  background: #0c6b60;\n  color: var(--White, #fff);\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.about__order_mobile__content > a \n{\n  width: 100%;\n  height: 42px;\n  border-radius: 8px;\n  background: #0c6b60;\n  color: var(--White, #fff);\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n.about__order_mobile__content > a > button \n{\n  background: unset;\n  border:none;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--White, #fff);\n}\n\n.calculation__box {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.calculation__title {\n  color: #fff;\n  font-size: 18px;\n  font-weight: 700;\n  padding: 6px 13px;\n  border-radius: 4px;\n  background: #0c6b60;\n}\n\n/* calculation__item_add */\n\n.calculation__title.v2 {\n  color: #777f87;\n  background: transparent;\n}\n\n.calculation__header_left {\n  width: calc(100% - 496px);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 32px;\n}\n\n.calculation__grades {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 30px;\n  list-style: none;\n}\n\n.calculation__grade {\ndisplay: flex;\n  align-items: center;\n  position: relative;\n  width: calc((100% - 60px) / 3);\n  border: 2px solid #b2bac663;\n  border-radius: 8px;\n  padding: 15px;\n  cursor: pointer;\n}\n\n.calculation__grade.active {\n  border: 2px solid #0c6b60;\n}\n\n\n..calculation__grades.washing .calculation__grade\n{\n  width: calc((100% - 60px) / 2);\n}\n\n.calculation__grade > img {\n  width: 100%;\n}\n\n.calculation__grade > .checkbox {\n  position: absolute;\n  bottom: -11px;\n  right: 11px;\n  width: 22px;\n  height: 22px;\n  display: none;\n}\n\n.calculation__grade > .checkbox.active {\n  display: block;\n}\n\n\n.calculation__select_color {\n  width: calc(((100% - 60px) / 3) * 2 + 30px);\n  height: 55px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 8px;\n  border: 1px solid #dde1eb;\n  background: var(--White, #fff);\n  padding: 0 16px;\n  cursor: pointer;\n}\n\n.calculation__select_color > i {\n  padding: 8px 16px;\n  border-radius: 4px;\n  background: #60656e;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n.calculation__select_color > span {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.calculation__select_color > span img {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.about__order {\n  width: 400px;\n  border-radius: 30px;\n  background: #fff;\n  box-shadow: 0px 0px 73.6px 0px rgba(42, 77, 114, 0.19);\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.about__order > h2 {\n  color: #777f87;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.about__order > input {\n  width: 100%;\n  height: 42px;\n  border-radius: 8px;\n  border: 1px solid #dde1eb;\n  background: var(--White, #fff);\n  padding: 0 16px;\n  color: #777f87;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.about__order > input::placeholder {\n  color: var(--Placeholder, #b2bac6);\n}\n\n.about__order > input[name=\"phone\"] {\n  letter-spacing: 2px;\n}\n\n.about__order > .order__price {\n  width: 100%;\n  height: 68px;\n  border-radius: 8px;\n  background: #dde1eb;\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* calculation__item_info */\n\n.about__order > .order__price p {\n  color: var(--Dark-Gray, #60656e);\n  font-size: 16px;\n  font-weight: 500;\n  flex: 0 0 80px;\n}\n\n.about__order > .order__price span {\n  color: #434343;\n  font-size: 32px;\n  font-weight: 700;\n}\n\n.about__order > .order__buttons {\n  width: 100%;\n  height: 56px;\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.about__order > .order__buttons > button, .about__order > a {\n  width: calc((100% - 16px) / 2);\n  border-radius: 8px;\n  background: #0c6b60;\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.about__order > a\n{\n  width: 100%;\n}\n.about__order > a > button\n{\n    border-radius: 8px;\n    background: #0c6b60;\n    border: none;\n    color: var(--White, #fff);\n    font-size: 16px;\n    font-weight: 600;\n    padding: 16px 5px;\n    width: 100%;\n    cursor: pointer;\n}\n\n.about__order > .order__buttons > button svg \n{\n  margin-right: 5px;\n\n}\n\n.about__order > button {\n  width: 100%;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: #0c6b60;\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  gap: 10px;\n}\n\n/* --------- calculation__detail ---------- */\n.calculation__detail {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.calculation__item {\n  position: relative;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #dde1eb;\n  background: #dde1eb;\n}\n\n.calculation__item_top {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 22px;\n  gap: 18px;\n  background: #fff;\n  border-radius: 8px;\n}\n\n.calculation__item_top > :where(div, label) {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.calculation__item_top > :where(div, label) > input {\n  width: 100%;\n  height: 45px;\n  padding: 0 16px;\n  border-radius: 8px;\n  border: 1px solid #dde1eb;\n  color: #777f87;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.calculation__item_top > :where(div, label).w270 {\n  width: 270px;\n}\n.calculation__item_top > :where(div, label).w145 {\n  width: 145px;\n}\n.calculation__item_top > :where(div, label).w135 {\n  width: 135px;\n}\n.calculation__item_top > :where(div, label).w100 {\n  width: 100px;\n}\n\n.calculation__item_top > :where(div, label).w100 input {\n  text-align: center;\n}\n\n.calculation__item_top > :where(div, label) > span {\n  color: #8f98a5;\n  font-size: 12px;\n}\n\n.calculation__item_info {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.calculation__item_info > p {\n  padding: 16px 20px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  border-color: #DDE1EB;\n  border-width: 1px;\n  border-style: solid;\n}\n\n.calculation__item_info > p i {\n  max-width: 120px;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n}\n\n.calculation__item_info > p span {\n  font-size: 28px;\n  font-weight: 700;\n}\n\n.select {\n  position: relative;\n  width: 100%;\n  height: 45px;\n  max-width: 540px;\n  background: yellow;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-right: 16px;\n  border: 1px solid var(--Border, #dde1eb);\n  border-radius: 8px;\n  background: var(--White, #fff);\n}\n\n.select.input {\n  padding: 0 16px;\n}\n\n.select.input > input {\n  padding: 0;\n}\n\n.select > input {\n  width: 100%;\n  height: 100%;\n  padding: 0 16px;\n  border-radius: 8px;\n  color: var(--Dark, #23262a);\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.select > svg {\n  font-size: 20px;\n  transition: all 0.3s ease;\n}\n\n.select.active svg {\n  transform: rotate(180deg);\n}\n\n.select__list {\n  position: absolute;\n  top: calc(100% + 5px);\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  max-height: 0px;\n  overflow-y: auto;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: var(--White, #fff);\n  transition: all 0.3s ease;\n}\n\n.select__list > li {\n  height: 40px;\n  padding: 0 16px;\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--Dark, #23262a);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.select__list > :nth-child(even) {\n  background: var(--Light, #f4f5f7);\n}\n\n.select__list > :nth-child(even):hover {\n  background: var(--Light, #f4f5f7e9);\n}\n\n.select__list > :nth-child(odd):hover {\n  background: var(--Light, #fbfbfb);\n}\n\n.select.active .select__list {\n  max-height: 200px;\n  border: 1px solid var(--Border, #dde1eb);\n}\n\n.calculation__item_bottom {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  border-radius: 8px;\n  padding: 15px 16px;\n  gap: 43px;\n  position: relative;\n}\n\n.calculation__item_bottom > p {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.calculation__item_bottom > p.red_noty\n{\n    color: red;\n    font-size: 12px;\n    display: block;\n    margin-bottom: 0px;\n    position: absolute;\n    top: 7px;\n    right: 10px;\n}\n.calculation__item_bottom > p > :where(i, span) {\n  font-style: normal;\n  color: #434343;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.calculation__item_add {\n  position: absolute;\n  right: 11px;\n  bottom: -11px;\n  /* width: 22px; */\n  height: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #0c6b60;\n  color: #fff;\n  font-size: 20px;\n  cursor: pointer;\n  border: none;\n  border-radius: 4px;\n  padding: 0 10px;\n}\n\n.calculation__item_add > span {\n  color: #fff;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.calculation__item_remove\n{\n  position: absolute;\n    right: 205px;\n    bottom: -11px;\n    /* width: 22px; */\n    height: 25px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #af0e0e;\n    color: #fff;\n    font-size: 20px;\n    cursor: pointer;\n    border: none;\n    border-radius: 4px;\n    padding: 0 10px;\n}\n\n.calculation__item_remove > span {\n  color: #fff;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.calculation__item_remove > svg\n{\n    transform: rotate(45deg);\n}\n\n/* ------------------------- */\n.calculation__additional {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 8px;\n  border: 1px solid #dde1eb;\n  background: #fff;\n  padding: 20px 40px;\n  gap: 30px;\n}\n\n\n.calculation__additional table {\n    width: 100%;\n    gap: 16px;\n}\n\n.calculation__additional table thead tr {\n    width: 100%;\n    background: #fff;\n    z-index: 99;\n    border: 1px solid transparent !important;\n}\n\n.calculation__additional table tr {\n  width: 100%;\n    background: #DDE1EB;\n    border: 1px solid transparent;\n    margin-bottom: 15px;\n}\n\n.calculation__additional table thead tr\n{\n  margin: 0;\n}\n\n.calculation__additional table tr {\n      width: 100%;\n    height: 65px;\n    border-radius: 8px;\n}\n\n.calculation__additional table tr:nth-child(odd) {\n  background: transparent;\n    border: 1px solid #dde1eb;\n}\n\n.calculation__additional table tr td {\n    height: 30px;\n    border-right: 1px solid #b2bac6;\n    padding: 0 5px;\n    color: #b2bac6;\n    font-size: 10px;\n    font-weight: 500;\n}\n\n.calculation__additional table tbody tr td \n{\n\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 17px;\n  color: #424242;\n}\n.calculation__additional table tr td\n{\n  width: 10%;\n  text-align: center;\n}\n.calculation__additional table tr td:last-child {\n    border-right: none;\n}\n\n.calculation__additional table tr td.title \n{\n  justify-content: left;\n  width: 60%;\n}\n.calculation__additional table tr td input\n{\n\n  background: #FFFFFF;\n  border: 1px solid #DDE1EB;\n  border-radius: 8px;\n  text-align: center;\n  padding: 10px;\n  width: 50px;\n}\n.calculation__additional table tr td .remove\n{\n    height: 25px;\n    background: #af0e0e;\n    color: #fff;\n    font-size: 19px;\n    cursor: pointer;\n    border: none;\n    border-radius: 4px;\n    padding: 0 2px;\n}\n\n.calculation__additional table tr td .remove svg \n{\n    transform: rotate(45deg);\n    margin-top: 2px;\n}\n\n.calculation__additional > button {\n  min-width: 300px;\n  color: #0c6b60;\n  font-size: 16px;\n  font-weight: 500;\n  border: none;\n  background: transparent;\n  text-decoration-line: underline;\n  cursor: pointer;\n}\n\n.calculation__additional > p {\n  max-width: 650px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.calculation__additional > p span {\n  color: #000;\n  font-size: 15px;\n  font-weight: 400;\n}\n\n/* ------------------------- */\n\n.calculation__total {\n  width: 100%;\n  padding: 30px;\n  border-radius: 8px;\n  background: #dde1eb;\n  display: flex;\n  align-items: center;\n  gap: 22px;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n.calculation__total > :where(p, div, button) {\n  width: calc((100% - 44px) / 3);\n  height: 56px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.calculation__total > p {\n  justify-content: space-between;\n  background: #fff;\n  padding: 0 16px;\n}\n\n.calculation__total > p i {\n  color: var(--Dark-Gray, #60656e);\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n.calculation__total > p span {\n  color: #434343;\n  font-size: 30px;\n  font-weight: 700;\n}\n\n.calculation__total > div {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n}\n\n.calculation__total > div button {\n  width: calc((100% - 22px) / 2);\n  height: 100%;\n  border-radius: 8px;\n  background: #0c6b60;\n  border: none;\n  color: var(--White, #fff);\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  padding: 0 16px;\n  cursor: pointer;\n}\n\n.calculation__total.three_button > div button\n{\n  width: calc(100% - 22px);\n}\n\n.calculation__total > button {\n  background: #0c6b60;\n  border: none;\n  color: var(--White, #fff);\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  gap: 5px;\n}\n\n.calculation__total > a \n{\n    background: #0c6b60;\n    border: none;\n    color: var(--White, #fff);\n    text-align: center;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    gap: 5px;\n    height: 56px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: calc((100% - 22px) / 2);\n    border-radius: 8px;\n}\n\n.calculation__total > a > button \n{\n  color: var(--White, #fff);\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  background: unset;\n  border:none;\n  padding: 0 16px;\n}\n\n/* --------- Media Query for Calculation Page ---------  */\n\n@media (max-width: 1280px) {\n  .calculation__item_top > :where(div, label).w270 {\n    width: 250px;\n  }\n  .calculation__item_top > :where(div, label).w145 {\n    width: 130px;\n  }\n  .calculation__item_top > :where(div, label).w135 {\n    width: 110px;\n  }\n  .calculation__item_top > :where(div, label).w100 {\n    width: 80px;\n  }\n}\n\n@media (max-width: 1150px) {\n  .calculation__header {\n    gap: 40px;\n  }\n\n  .calculation__header_left {\n    width: calc(100% - 440px);\n    gap: 30px;\n  }\n\n  .calculation__grades {\n    gap: 15px;\n  }\n\n  .calculation__grade {\n    width: calc((100% - 30px) / 3);\n    padding: 10px;\n  }\n\n  .calculation__select_color {\n    width: 100%;\n  }\n\n  .calculation__select_color > i {\n    font-size: 14px;\n  }\n\n  .calculation__item_top > :where(div, label) input {\n    font-size: 14px;\n  }\n\n  .calculation__item_top > :where(div, label).w270 {\n    width: 230px;\n  }\n  .calculation__item_top > :where(div, label).w145 {\n    width: 105px;\n  }\n  .calculation__item_top > :where(div, label).w135 {\n    width: 90px;\n  }\n  .calculation__item_top > :where(div, label).w100 {\n    width: 70px;\n  }\n\n  .calculation__total > p i {\n    font-size: 14px;\n  }\n\n  .calculation__total > p span {\n    font-size: 24px;\n    font-weight: 700;\n  }\n\n  .calculation__total > div button {\n    font-size: 14px;\n  }\n\n  .calculation__item_info > p {\n    padding: 10px 15px;\n  }\n\n  .calculation__item_info > p i {\n    max-width: 120px;\n    font-size: 10px;\n  }\n\n  .calculation__item_info > p span {\n    font-size: 24px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .calculation__header {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .about__order {\n    display: none;\n  }\n\n  .about__order_mobile {\n    display: flex;\n  }\n\n  .calculation__header_left {\n    width: 100%;\n  }\n\n  .calculation__grade {\n    width: calc((100% - 45px) / 4);\n  }\n\n  .calculation__title {\n    font-size: 16px;\n    font-weight: 600;\n    padding: 5px 10px;\n  }\n\n  .calculation__total {\n    padding: 30px;\n    gap: 20px;\n    flex-wrap: wrap;\n  }\n\n  .calculation__total > p {\n    width: 100%;\n  }\n\n  .calculation__total > :where(div, button) {\n    width: calc((100% - 20px) / 2);\n  }\n}\n\n@media (max-width: 768px) {\n  .calculation__grade {\n    width: calc((100% - 30px) / 3);\n  }\n\n  .calculation__item_info {\n    width: 100%;\n    gap: 8px;\n    padding-top: 10px;\n  }\n\n  .calculation__item_info > p {\n    width: calc((100% - 8px) / 2);\n    padding: 15px;\n  }\n\n  .calculation__item_info > p span {\n    font-size: 20px;\n  }\n\n  .calculation__additional {\n    width: 100%;\n    display: flex;\n    flex-direction: column-reverse;\n    padding: 25px 20px;\n    gap: 20px;\n  }\n\n  .calculation__additional > button {\n    max-width: auto;\n    font-size: 14px;\n  }\n\n  .calculation__additional > p {\n    flex-direction: column;\n  }\n\n  .calculation__additional > p span {\n    font-size: 14px;\n    text-align: center;\n  }\n\n  .calculation__total > div {\n    width: 100%;\n  }\n\n  .calculation__total > button {\n    width: 100%;\n  }\n}\n\n@media (max-width: 525px) {\n  .calculation__grade {\n    width: calc((100% - 15px) / 2);\n  }\n\n  .calculation__item_bottom {\n    padding: 15px;\n    gap: 20px;\n  }\n\n  .calculation__item_info p {\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n  }\n\n  .calculation__item_info i {\n    text-align: center;\n  }\n\n  .calculation__item_top {\n    gap: 10px;\n  }\n\n  .calculation__item_top > :where(div, label) {\n    width: calc((100% - 10px) / 2) !important;\n  }\n\n  .calculation__total {\n    padding: 16px;\n    gap: 10px;\n  }\n\n  .calculation__total > p {\n    padding: 0 14px;\n  }\n\n  .calculation__total > p i {\n    font-size: 12px;\n  }\n\n  .calculation__total > p span {\n    font-size: 24px;\n  }\n\n  .calculation__total > div {\n    gap: 10px;\n  }\n\n  .calculation__total > div button {\n    width: calc((100% - 10px) / 2);\n    font-size: 14px;\n  }\n\n  .calculation__total > button {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 400px) {\n  .calculation__item_top > :where(div) {\n    width: 100% !important;\n  }\n\n  .calculation__item_bottom {\n    flex-wrap: wrap;\n  }\n}\n\n\n.calculation__select_new .react-select__control\n{\n  width: 100%;\n}\n.calculation__select_new .react-select__value-container .react-select__single-value .span\n{\n    font-size: 14px !important;\n    padding: 4px 0!important;\n}\n\n.calculation__select_new img\n{\n    width: 20px !important;\n    height: 20px !important;\n    margin-top: 12px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
